import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/AutonomousMaintenanceCalendarActions";
import * as api from "../../api/AutonomousMaintenanceCalendarApi";
import { showSnackMessage } from "../actions/AutonomousMaintenanceCalendarActions";

function* getTaskList(action) {
    try {
        const { data } = yield api.getTaskList(action.payload);

        yield put(actions.setTaskList(data || undefined));
    } catch (error) {
        yield put(actions.setTaskList(undefined));
        yield put(showSnackMessage(error, "error"));
    }
}

function* getupdateTaskDate(action) {
    try {
        const { data } = yield api.getupdateTaskDate(action.payload);
        yield put(actions.setupdateTaskDate(data || undefined));
    } catch (error) {
        yield put(actions.setupdateTaskDate(undefined));
        yield put(showSnackMessage(error, "error"));
    }
}

// function* getStatusList(action) {

//     try {

//         const { data } = yield api.getStatusList(action.payload)
//         yield put(actions.setStatusList(data || undefined));

//     } catch (error) {
//         yield put(actions.setStatusList(undefined));
//         yield put(showSnackMessage(error, 'error'));
//     }
// }
function* getTaskDetailById(action) {
    try {
        const { data } = yield api.getTaskDetailById(action.payload);

        yield put(actions.setTaskDetailById(data || undefined));
    } catch (error) {
        yield put(actions.setTaskDetailById(undefined));
        yield put(showSnackMessage(error, "error"));
    }
}

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();

        yield put(actions.setAreaList(data || undefined));
    } catch (error) {
        yield put(actions.setAreaList(undefined));
        yield put(showSnackMessage(error, "error"));
    }
}

function* getEquipmentSubListById() {
    try {
        const { data } = yield api.getEquipmentSubListById();

        yield put(actions.setEquipmentSubListById(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentSubListById(undefined));
        yield put(showSnackMessage(error, "error"));
    }
}

function* getListMaintenanceType() {
    try {
        const { data } = yield api.getListMaintenanceType();

        yield put(actions.setListMaintenanceType(data || undefined));
    } catch (error) {
        yield put(actions.setListMaintenanceType(undefined));
        yield put(showSnackMessage(error, "error"));
    }
}

function* getList(action) {
    try {
        const { data } = yield api.getList(action.payload);
        yield put(actions.setList(data || undefined));
    } catch (error) {
        yield put(actions.setList(undefined));
        yield put(showSnackMessage(error, "error"));
    }
}

function* getMainListByAreaID(action) {
    try {
        const { data } = yield api.getMainListByAreaID(action.payload);

        yield put(actions.setMainListByAreaID(data || undefined));
    } catch (error) {
        yield put(actions.setMainListByAreaID(undefined));
        yield put(showSnackMessage(error, "error"));
    }
}

function* getSubListById(action) {
    try {
        const { data } = yield api.getSubListById(action.payload);

        yield put(actions.setSubListById(data || undefined));
    } catch (error) {
        yield put(actions.setSubListById(undefined));
        yield put(showSnackMessage(error, "error"));
    }
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_TASKS_PAGE, getTaskList);
    yield takeEvery(actions.Types.GET_UPDATE_TASK_DATE, getupdateTaskDate);
    yield takeEvery(actions.Types.GET_AREA_LIST, getAreaList);
    yield takeEvery(actions.Types.GET_TASK_DETAIL_BY_ID, getTaskDetailById);
    yield takeEvery(actions.Types.GET_EQUIPMENT_SUB_LIST_BY_ID, getEquipmentSubListById);
    yield takeEvery(actions.Types.GET_LIST_MAINTATENANCE_TYPE, getListMaintenanceType);
    yield takeEvery(actions.Types.GET_POOL_LIST, getList);
    yield takeEvery(actions.Types.GET_MAIN_LIST_BY_AREA_ID, getMainListByAreaID);
    yield takeEvery(actions.Types.GET_SUB_LIST_BY_AREA_ID, getSubListById);
}
const AutonomousMaintenanceCalendarSaga = [fork(watchAll)];

export default AutonomousMaintenanceCalendarSaga;
